export interface IMfrmStatesValues {
    stateName: string;
    message: string;
    zipcodeMessage: string;
    hasStore:boolean;
    hideCheckoutState:boolean;
}

export const getBlockZipCodeMessage = (stateName: string, blockStatesArray: IMfrmStatesValues[]) => {
    if (blockStatesArray) {
        return blockStatesArray.filter((blockstate: IMfrmStatesValues) => {
            return blockstate.stateName === stateName;
        });
    }
    return [];
};
